"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = stringify;
const event_emitter_promisify_1 = require("event-emitter-promisify");
function stringify(ee) {
    return __awaiter(this, void 0, void 0, function* () {
        let str = '';
        ee.on('data', (chunk) => {
            str += chunk;
        });
        yield (0, event_emitter_promisify_1.promisifyEventEmitter)(ee);
        return str;
    });
}
